import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useStore } from "@/context/StoreContext";
import { Field, Notice, PageShell } from "@/components/site/Layout";

export const WaitlistForm = ({ source }) => {
  const { config } = useStore();
  const [f, setF] = useState({ email: "", name: "", consent: false, website: "" });
  const [state, setState] = useState({ loading: false, done: null, error: null });
  const submit = async (e) => {
    e.preventDefault();
    setState({ loading: true });
    try {
      const { data } = await api.post("/waitlist", { ...f, source });
      setState({ done: data.status });
    } catch (err) {
      setState({ error: errMsg(err) });
    }
  };
  if (state.done)
    return <Notice testid="waitlist-success">{state.done === "already_confirmed" ? "You're already on the launch list. Thank you!" : state.done === "suppressed" ? "This address has unsubscribed. Contact us if you'd like to rejoin." : "Thanks! Please check your inbox and confirm your email to join the list."}</Notice>;
  return (
    <form onSubmit={submit} className="grid gap-4" noValidate data-testid="waitlist-form">
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label="Email" id="wl-email"><input id="wl-email" type="email" required className="hn-input" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="waitlist-email-input" autoComplete="email" /></Field>
        <Field label="First name (optional)" id="wl-name"><input id="wl-name" className="hn-input" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="waitlist-name-input" /></Field>
      </div>
      <input type="text" tabIndex={-1} autoComplete="off" className="hidden" aria-hidden value={f.website} onChange={(e) => setF({ ...f, website: e.target.value })} />
      <label className="flex gap-3 text-sm items-start">
        <input type="checkbox" className="mt-1 accent-[#173B2D]" checked={f.consent} onChange={(e) => setF({ ...f, consent: e.target.checked })} data-testid="waitlist-consent-checkbox" />
        <span>{config?.waitlist?.consent_text}</span>
      </label>
      {state.error && <Notice tone="error" testid="waitlist-error">{state.error}</Notice>}
      <button className="hn-btn justify-self-start" disabled={state.loading} data-testid="waitlist-submit-btn">{state.loading ? "Joining…" : "Join the launch list"}</button>
    </form>
  );
};

export function WaitlistConfirm() {
  const [sp] = useSearchParams();
  const [s, setS] = useState(null);
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    api.post("/waitlist/confirm", { token: sp.get("token") || "" }).then(() => setS({ ok: true })).catch((e) => setS({ error: errMsg(e) }));
  }, [sp]);
  return (
    <PageShell narrow>
      <h1 className="text-4xl mb-6">Launch list</h1>
      {!s ? <p>Confirming…</p> : s.ok ? <Notice testid="waitlist-confirmed">You're confirmed. We'll email you when HONEY NUTS is available.</Notice> : <Notice tone="error">{s.error}</Notice>}
      <Link to="/" className="hn-btn mt-8">Back to home</Link>
    </PageShell>
  );
}

export function Unsubscribe() {
  const [sp] = useSearchParams();
  const [s, setS] = useState(null);
  const go = () => api.post("/unsubscribe", { email: sp.get("email"), token: sp.get("token") }).then(() => setS({ ok: true })).catch((e) => setS({ error: errMsg(e) }));
  return (
    <PageShell narrow>
      <h1 className="text-4xl mb-6">Unsubscribe</h1>
      {s?.ok ? <Notice testid="unsubscribed">You've been unsubscribed from marketing emails. Order emails will still arrive if you place an order.</Notice> : (
        <>
          <p className="mb-6">Stop marketing emails to <strong>{sp.get("email")}</strong>?</p>
          {s?.error && <Notice tone="error">{s.error}</Notice>}
          <button className="hn-btn mt-4" onClick={go} data-testid="unsubscribe-confirm-btn">Unsubscribe</button>
        </>
      )}
    </PageShell>
  );
}
